import yaml from "yaml";

// yaml doesn't export its types so we have to rewrite them :()
interface YamlPair {
  key: YamlNode;
  value: YamlNode;
}

interface YamlNode {
  cstNode?: any;
  type?: string;
  items?: YamlPair[] | YamlNode[];
}

// The Semgrep backend uses a Python YAML parser that is less tolerant to possible YAML formats.
// Specifically, the js yaml library will allow non-string object keys, while the Python library will not.
// Here we reject any objects without plain keys.
const validateNode = (node: YamlNode) => {
  if (!node || !node.type) return;
  if (node.type === "SEQ") {
    for (const n of node.items as YamlNode[]) {
      validateNode(n);
    }
  }
  if (node.type === "MAP" || node.type === "FLOW_MAP") {
    for (const p of node.items as YamlPair[]) {
      if (p.key.type !== "PLAIN") {
        const err = new Error(
          "Got non-string key for object property. You may need to add quotes around string literals with braces."
        );
        (err as any).linePos = p.key.cstNode?.rangeAsLinePos;
        throw err;
      }
      validateNode(p.value);
    }
  }
};

export const validateYaml = (str: string): yaml.Document.Parsed => {
  const doc = yaml.parseDocument(str, {
    prettyErrors: true,
    keepCstNodes: true,
  });
  if (doc.contents !== null) {
    validateNode(doc.contents);
  }
  if (doc.errors.length > 0) throw doc.errors[0];
  return doc;
};
